module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel-7 nopadding-r\"><span>Target Field</span></div>\r\n    <div class=\"col-md-5\" style=\"padding-left: 0; padding-right: 5px\">\r\n        <input type=\"text\" name=\"targetFieldName\" value=\"")
    ; __append(escapeFn(targetFieldName))
    ; __append("\" readonly=\"readonly\"/>\r\n    </div>\r\n    <div class=\"col-md-3 nopadding\">\r\n        <input class=\"btn btn-default hvr-glow\" type=\"button\" id=\"targetField\" name =\"targetField\" value=\"Select\">\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n")
  }
  return __output;

}